export const NAMES = {
  CLASS_ROOT: "ab-lb",
  CLASS_IMAGE: "ab-lb__image",
  LIGHTBOX_DISABLED: "disable-ablb",
}
